import { isAttendingVote } from "./vote-utils";

export const RSVP = {
  GOING: "GOING",
  MAYBE: "MAYBE",
  CANT_GO: "CANT_GO",
};

export function rsvpLabel(value) {
  switch (value) {
    case RSVP.GOING:
      return "Going";
    case RSVP.MAYBE:
      return "Maybe";
    case RSVP.CANT_GO:
      return "Can't go";
    default:
      return null;
  }
}

export function effectiveRsvp(voteDoc, winningSlotId) {
  if (!voteDoc) return null;
  if (voteDoc.rsvp) return voteDoc.rsvp;
  if (!winningSlotId) return null;
  if (voteDoc.noTimesWork) return null;
  const vote = voteDoc.votes?.[winningSlotId];
  if (isAttendingVote(vote)) return RSVP.GOING;
  return null;
}

export function buildRsvpSummary(voteDocs, winningSlotId, participantIds) {
  const going = [];
  const maybe = [];
  const cantGo = [];
  const respondedIds = new Set();

  (voteDocs || []).forEach((voteDoc) => {
    if (!voteDoc?.id) return;
    const rsvp = effectiveRsvp(voteDoc, winningSlotId);
    // Only mark "responded" when the doc actually buckets — a vote doc with no
    // effective RSVP for the winning slot (e.g. voted a non-winning slot, or a
    // pre-materialization legacy doc) must fall through to noResponse, not vanish.
    switch (rsvp) {
      case RSVP.GOING:
        going.push(voteDoc.id);
        respondedIds.add(voteDoc.id);
        break;
      case RSVP.MAYBE:
        maybe.push(voteDoc.id);
        respondedIds.add(voteDoc.id);
        break;
      case RSVP.CANT_GO:
        cantGo.push(voteDoc.id);
        respondedIds.add(voteDoc.id);
        break;
      default:
        break;
    }
  });

  const noResponse = (participantIds || []).filter(
    (id) => !respondedIds.has(id)
  );

  return { going, maybe, cantGo, noResponse };
}
